import { withNamespaces } from 'react-i18next';
import {
    Alert,
    Card,
    CardBody,
    CardTitle,
    Progress,
} from 'reactstrap';

import useSupplierByRiskLevel from './hooks/useSupplierByRiskLevel';

const SupplierByRiskLevelSkeleton = () => (
    <Card className="h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '50%', height: '24px' }} />
            {[1, 2, 3, 4].map((item) => (
                <div key={item} className="dt-field dt-skeleton mb-3" style={{ width: '100%', height: '24px' }} />
            ))}
            <div className="dt-field dt-skeleton mt-4" style={{ width: '100%', height: '48px' }} />
        </CardBody>
    </Card>
);

const SupplierByRiskLevel = ({
    t,
}) => {
    const {
        levels,
        highAndVeryHighTotal,
        isLoading,
        isFetching,
        isError,
    } = useSupplierByRiskLevel({ t });

    if (isLoading || isFetching) {
        return <SupplierByRiskLevelSkeleton />;
    }

    if (isError || !levels?.length) {
        return null;
    }

    return (
        <Card className="h-100 mb-0">
            <CardBody className="d-flex flex-column">
                <CardTitle tag="h6" className="mb-4">
                    {t('Supplier by Risk Level')}
                </CardTitle>

                <div className="flex-grow-1">
                    {levels.map((level) => (
                        <div
                            key={level.key}
                            className="d-flex align-items-center gap-3 mb-3"
                        >
                            <span className="flex-shrink-0" style={{ minWidth: '80px' }}>
                                {level.label}
                            </span>

                            <Progress
                                className="flex-grow-1 mb-0"
                                color={level.color}
                                value={level.percentage}
                            />

                            <span className="fw-semibold flex-shrink-0 text-end" style={{ minWidth: '32px' }}>
                                {level.value}
                            </span>
                        </div>
                    ))}
                </div>

                <Alert color="warning" className="mb-0 mt-auto">
                    <div className="d-flex justify-content-between align-items-center gap-2">
                        <span>
                            {t('High and Very High Risk Suppliers')}
                        </span>
                        <span className="fw-semibold flex-shrink-0">
                            {highAndVeryHighTotal}
                        </span>
                    </div>
                </Alert>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(SupplierByRiskLevel);
